import React from 'react';
import HorizontalLinearStepper from "./HorizontalStepper";
import {Box, Grid, Typography} from "@mui/material";
import backgroundlg from '../assets/img/dottedBGLarge.png'
import backgroundsmall from '../assets/img/dottedBGSmall.png'
import background2 from '../assets/img/HometutorBG2.png'
import VerticalLinearStepper from "./VerticalLinearStepper";
import WhyUsCard from "./WhyUsCard";


const FilterBodyComponent = () => {
    return (
        <Box>
            <Typography variant='h4' style={{marginTop: '12rem', paddingLeft: 32}}>Search Filter</Typography>
            <Box sx={{marginTop: "3%"}}>
                <Grid container spacing={2}>
                    <Grid item md={7}>
                        <Box
                            sx={{
                                backgroundImage: {xs: `url("${backgroundsmall}")`, sm: `url("${backgroundlg}")`},
                                height: {xs: 317, sm: 577},
                                width: {xs: 375, sm: 678},
                                backgroundSize: "auto",
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'column'
                            }}
                        >

                            <Box>
                                <HorizontalLinearStepper style={{paddingLeft: 26}}/>

                                <VerticalLinearStepper style={{paddingLeft: 26}}/>
                            </Box>
                            <Box sx={{display: {xs: 'none', sm: 'block', md: 'block', lg: 'block'},}}>
                                <WhyUsCard/>
                            </Box>

                        </Box>
                    </Grid>
                    <Grid item md={5} sx={{display: {xs: 'none', sm: 'none', md: 'block', lg: 'block'}}}>
                        <div style={{
                            backgroundImage: `url("${background2}")`,
                            height: 515,
                            width: 527,
                            backgroundSize: "auto"
                        }}>
                        </div>
                    </Grid>
                </Grid>
            </Box>

        </Box>
    );
};

export default FilterBodyComponent;